/**
 * Vuex store module for WebSocket state management
 */
const state = {
  isConnected: false,
  messages: [],
  lastMessage: null,
  notifications: [],
};

const mutations = {
  SET_CONNECTION_STATUS(state, status) {
    state.isConnected = status;
  },
  ADD_MESSAGE(state, message) {
    state.messages.push(message);
    state.lastMessage = message;

    // Keep only the last 50 messages in memory
    if (state.messages.length > 50) {
      state.messages.shift();
    }
  },
  ADD_NOTIFICATION(state, notification) {
    state.notifications.push(notification);

    // Keep only the last 20 notifications
    if (state.notifications.length > 20) {
      state.notifications.shift();
    }
  },
  MARK_NOTIFICATION_READ(state, notificationId) {
    const target = state.notifications.find(
      (notification) => notification.id === notificationId
    );
    if (target) {
      target.read = true;
    }
  },
  CLEAR_NOTIFICATIONS(state) {
    state.notifications = [];
  },
};

const actions = {
  setConnectionStatus({ commit }, status) {
    commit("SET_CONNECTION_STATUS", status);
  },
  messageReceived({ commit }, message) {
    commit("ADD_MESSAGE", message);

    const notificationPayload =
      message?.event === "notification" ? message.payload : message;

    // If the message is a notification type, add it to notifications
    if (
      notificationPayload &&
      (notificationPayload.type || message?.type) &&
      ["notification", "alert", "update", "reminder"].includes(
        notificationPayload.type || message.type
      )
    ) {
      const notificationType = notificationPayload.type || message.type;
      const notificationId =
        notificationPayload.data?.message_id ||
        notificationPayload.data?.application_id ||
        message.id ||
        `${notificationType}-${notificationPayload.timestamp || Date.now()}`;

      commit("ADD_NOTIFICATION", {
        id: notificationId,
        type: notificationType,
        title:
          notificationPayload.data?.title ||
          notificationPayload.title ||
          notificationPayload.message,
        message:
          notificationPayload.message || notificationPayload.content || "",
        data: notificationPayload.data || {},
        link:
          notificationPayload.data?.link ||
          notificationPayload.link ||
          notificationPayload.data?.url ||
          null,
        read: false,
        timestamp:
          notificationPayload.timestamp ||
          message.timestamp ||
          new Date().toISOString(),
      });
    }
  },
  markNotificationAsRead({ commit }, notificationId) {
    commit("MARK_NOTIFICATION_READ", notificationId);
  },
  clearNotifications({ commit }) {
    commit("CLEAR_NOTIFICATIONS");
  },
};

const getters = {
  isConnected: (state) => state.isConnected,
  lastMessage: (state) => state.lastMessage,
  allMessages: (state) => state.messages,
  unreadNotifications: (state) => state.notifications.filter((n) => !n.read),
  allNotifications: (state) => state.notifications,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
